
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { PartesAmparoProps } from "../recepcion/AmparoInterface";
import { UsuarioPoderEnLineaProps } from "../admin/UsuarioInterface";
import { NotificacionArchivoProps } from "../notificaciones/NotificacionesInterface";

// Definición de defaults

export const defaultExpediente: ExpedienteProps = {
    idExpediente:               0,
    numeroExpediente:           '',
    numeroFolio:                '',
    numeroExpedientePrincipal:  '',
    cuantia:                    '',
    idTipoJuicio:               0,
    tipoJuicio:                 '',
    idTipoCalificacion:         0,
    tipoCalificacion:           '',
    idEtapa:                    0,
    etapa:                      '',
    idSubEtapa:                 0,
    subEtapa:                   '',
    estatus:                    '',
    audiencias:                 false,
    idJuez:                     0,
    juez:                       '',
    idSecretarioAdmisibilidad:  0,
    secretarioAdmisibilidad:    '',
    idSecretarioTramite:        0,
    secretarioTramite:          '',
    idSecretarioTramiteMenor:   0,
    secretarioTramiteMenor:     '',
    idSecretarioEjecucion:      0,
    secretarioEjecucion:        '',
    idJuzgadoOrigen:            0,
    juzgadoOrigen:              '',
    prestaciones:               [],
    actor:                      [],
    demandado:                  [],
    expedienteAutorizados:      [],
    expedientesAcumulados:      [],
    medioImpugnacion:           false,
    incidente:                  false,
}

export const defaultExhortoRecibido: ExhortoRecibidoProps = {
    idExhortoRecibido:          0,
    numeroExhorto:              '',
    numeroExpedienteOrigen:     '',
    numeroFolio:                '',
    cuantia:                    '',
    idTipoJuicio:               0,
    tipoJuicio:                 '',
    estatus:                    '',
    idObjetoExhorto:            0,
    objetoExhorto:              '',
    idClaseExhorto:             0,
    claseExhorto:               '',
    idAutoridadExhortoRecibido: 0,
    autoridadExhortoRecibido:   '',
    idJuzgadoOrigen:            0,
    juzgadoOrigen:              '',
    idJuez:                     0,
    juez:                       '',
    idSecretario:               0,
    secretario:                 '',
    idEtapa:                    0,
    etapa:                      '',
    idSubEtapa:                 0,
    subEtapa:                   '',
    seNotifico:                 false,
    actor:                      [],
    demandado:                  [],
}

export const defaultIrregular: IrregularProps = {
    idIrregular:        0,
    numeroIrregular:    '',
    numeroExpediente:   '',
    idTipoIrregular:    0,
    tipoIrregular:      '',
    estatus:            '',
    idJuzgadoOrigen:    0,
    juzgadoOrigen:      '',
    idJuez:             0,
    juez:               '',
    idSecretario:       0,
    secretario:         '',
    idEtapa:            0,
    etapa:              '',
    idSubEtapa:         0,
    subEtapa:           '',
    actor:              [],
    demandado:          [],
}

export const defaultAmparo: AmparoProps = {
    idAmparo:           0,
    numeroAmparo:       '',
    numeroExpediente:   '',
    numeroAmparoOrigen: '',
    estatus:            '',
    idJuez:             0,
    juez:               '',
    idSecretario:       0,
    secretario:         '',
    idTipoAmparo:       0,
    tipoAmparo:         '',   
    idSentidoAmparo:    0,
    sentidoAmparo:      '',
    idAutoridadAmparo:  0,
    autoridadAmparo:    '',
    idJuzgadoOrigen:    0,
    juzgadoOrigen:      '',
    partes:             [],
}

export const defaultExpedienteVirtual: ExpedienteVirtualProps = { expediente: defaultExpediente, exhortoRecibido: defaultExhortoRecibido, irregular: defaultIrregular, amparo: defaultAmparo, acuerdos: [] }

export const defaultExpedienteVirtualAcuerdos : AcuerdoProps = { idListaAcuerdo: 0, tipoAcuerdo: '', documento: '', folioBuzonElectronico: '', numeroSeguimiento: '', publicado: false, firmado: false }

export const defaultExpedienteVirtualResponse : ExpedienteVirtualResponse = { ...defaultHttpResponse, ...defaultExpedienteVirtual }

export const defaultExpedienteAutorizado: ExpedienteAutorizadoProps = {
    idExpedienteAutorizado:    '',
    referencia:                '',
    correoElectronico:         '',
    nombre:                    '',
    apellido1:                 '',
    apellido2:                 '',
    telefonoCelular:           '',
    activo:                    false,
}

export const defaultAutorizarExpedienteVirtualResponse: AutorizarExpedienteVirtualResponse = { ...defaultHttpResponse, expedienteAutorizado: defaultExpedienteAutorizado }

// Creación de interfaces

export interface ObtenerExpedienteVirtualParams {
    numeroReferencia:     string;
    idAutoridad:          number;
    idTipoConsecutivo:    number;
}

export interface ExpedienteVirtualProps {
    expediente:         ExpedienteProps;
    exhortoRecibido:    ExhortoRecibidoProps;
    irregular:          IrregularProps;
    amparo:             AmparoProps;
    acuerdos:           AcuerdoProps[];
}

export interface ExpedienteVirtualResponse extends ExpedienteVirtualProps, HttpResponse { }

export interface ExpedienteAutorizadoProps {
    idExpedienteAutorizado:     string;
    referencia:                 string;
    correoElectronico:          string;
    nombre:                     string;
    apellido1:                  string;
    apellido2:                  string;
    telefonoCelular:            string;
    activo:                     boolean;
}

export interface AcuerdoProps {
    idListaAcuerdo:         number;
    tipoAcuerdo:            string;
    documento:              string;
    folioBuzonElectronico:  string;
    numeroSeguimiento:      string;
    publicado:              boolean;
    firmado:                boolean;
    fecha?:                 Date;
    archivos?:              NotificacionArchivoProps[];
}

export interface ExpedienteProps {
    idExpediente:               number;
    numeroExpediente:           string;
    numeroFolio:                string;
    numeroExpedientePrincipal:  string;
    cuantia:                    string;
    idTipoJuicio:               number;
    tipoJuicio:                 string;
    idTipoCalificacion:         number;
    tipoCalificacion:           string;
    idEtapa:                    number;
    etapa:                      string;
    idSubEtapa:                 number;
    subEtapa:                   string;
    estatus:                    string;
    audiencias:                 boolean;
    idJuez:                     number;
    juez:                       string;
    idSecretarioAdmisibilidad:  number;
    secretarioAdmisibilidad:    string;
    idSecretarioTramite:        number;
    secretarioTramite:          string;
    idSecretarioTramiteMenor:   number;
    secretarioTramiteMenor:     string;
    idSecretarioEjecucion:      number;
    secretarioEjecucion:        string;
    idJuzgadoOrigen:            number;
    juzgadoOrigen:              string;
    prestaciones:               string[];
    actor:                      string[];
    demandado:                  string[];
    expedienteAutorizados:      ExpedienteAutorizadoProps[];
    expedientesAcumulados:      string[];
    medioImpugnacion:           boolean;
    incidente:                  boolean;
    fecha?:                     Date;
}

export interface ExhortoRecibidoProps {
    idExhortoRecibido:          number;
    numeroExhorto:              string;
    numeroExpedienteOrigen:     string;
    numeroFolio:                string;
    cuantia:                    string;
    idTipoJuicio:               number;
    tipoJuicio:                 string;
    estatus:                    string;
    idObjetoExhorto:            number;
    objetoExhorto:              string;
    idClaseExhorto:             number;
    claseExhorto:               string;
    idAutoridadExhortoRecibido: number;
    autoridadExhortoRecibido:   string;
    idJuzgadoOrigen:            number;
    juzgadoOrigen:              string;
    idJuez:                     number;
    juez:                       string;
    idSecretario:               number;
    secretario:                 string;
    idEtapa:                    number;
    etapa:                      string;
    idSubEtapa:                 number;
    subEtapa:                   string;
    seNotifico:                 boolean;
    actor:                      string[];
    demandado:                  string[];
    fecha?:                     Date;
    fechaDiligencia?:           Date;
    fechaDevolucion?:           Date;
}

export interface IrregularProps {
    idIrregular:        number;
    numeroIrregular:    string;
    numeroExpediente:   string;
    idTipoIrregular:    number;
    tipoIrregular:      string;
    estatus:            string;
    idJuzgadoOrigen:    number;
    juzgadoOrigen:      string;
    idJuez:             number;
    juez:               string;
    idSecretario:       number;
    secretario:         string;
    idEtapa:            number;
    etapa:              string;
    idSubEtapa:         number;
    subEtapa:           string;
    actor:              string[];
    demandado:          string[];
    fecha?:             Date;
}

export interface AmparoProps {
    idAmparo:                   number;
    numeroAmparo:               string;
    numeroExpediente:           string;
    numeroAmparoOrigen:         string;
    estatus:                    string;
    idJuez:                     number;
    juez:                       string;
    idSecretario:               number;
    secretario:                 string;
    idTipoAmparo:               number;
    tipoAmparo:                 string;
    idSentidoAmparo:            number;
    sentidoAmparo:              string;
    idAutoridadAmparo:          number;
    autoridadAmparo:            string;
    idJuzgadoOrigen:            number;
    juzgadoOrigen:              string;
    partes:                     PartesAmparoProps[];
    fecha?:                     Date;
    fechaInformePrevio?:        Date;
    fechaInformeJustificado?:   Date;
    fechaInterpone?:            Date;
    fechaResolucion?:           Date;
}

export interface CambiarEstatusExpedienteAutorizadoParams {
    referencia:                 string;
    idExpedienteAutorizado:     string;
    activar:                    boolean;
}

export interface AutorizarExpedienteVirtualParams {
    idExpediente:               number;
    usuarioPoderEnLinea:        UsuarioPoderEnLineaProps;
}

export interface AutorizarExpedienteVirtualResponse extends HttpResponse {
    expedienteAutorizado:       ExpedienteAutorizadoProps;
}

export interface AudienciaExpedienteProps {
    idAgenda:        number;
    tipoAudiencia:   string;
    estatus:         string;
    fecha:           Date;
}

export interface ObtenerEtapasExpedienteParams {
    idExpediente:        number;
    idExhortoRecibido:   number;
    idIrregular:         number;
}

export interface EtapaProps {
    etapa:      string;
    subEtapa:   string;
    fecha:      Date;
}

export interface EditarExpedienteParams {
    idExpediente:               number;
    idTipoJuicio:               number;
    idJuez:                     number;
    idSecretarioAdmisibilidad:  number;
    idSecretarioTramite:        number;
    idSecretarioTramiteMenor:   number;
    idSecretarioEjecucion:      number;
    cuantia:                    string;
    idEtapa:                    number;
    idSubEtapa:                 number;
    medioImpugnacion:           boolean;
    incidente:                  boolean;
}

export interface EditarExhortoRecibidoParams {
    idExhortoRecibido:          number;
    idTipoJuicio:               number;
    idObjetoExhorto:            number;
    idClaseExhorto:             number;
    idAutoridadExhortoRecibido: number;
    idJuez:                     number;
    idSecretario:               number;
    cuantia:                    string;
    idEtapa:                    number;
    idSubEtapa:                 number;
}

export interface EditarIrregularParams {
    idIrregular:        number;
    idTipoIrregular:    number;
    idJuez:             number;
    idSecretario:       number;
    idEtapa:            number;
    idSubEtapa:         number;
}

export interface EditarAmparoParams {
    idAmparo:                   number;
    idSentidoAmparo:            number;
    idAutoridadAmparo:          number;
    idTipoAmparo:               number;
    idJuez:                     number;
    idSecretario:               number;
    numeroAmparoOrigen:         string;
    fechaInformePrevio:         string;
    fechaInformeJustificado:    string;
    fechaInterpone:             string;
    fechaResolucion:            string;
}